export default __webpack_public_path__ + "static/hovedbilde-fd4ccef6afd38cf62e4432f0da07b29f.jpg";